import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-锚地",
  "use": "icon-锚地-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-锚地\">\r\n<path d=\"M145.8,122.6l12.6,7.6c-12.7,15.3-30.9,24.9-50.6,26.7v-26.1h22.6V117h-22.5V93.6c20.5-3.7,35.5-21.6,35.5-42.4\r\n\tC143.4,27.4,124,8,100.2,8l0,0C76.4,8,57.1,27.3,57.1,51.1v1.3c0.6,21,16.3,38.5,37,41.4V117H71.2v13.7h22.9v26.1\r\n\tc-20.1-1.7-38.7-11.6-51.5-27.3l11.8-7.1l-35.7-19.8l0.7,40.9l11.4-6.9c15.4,19.8,38.3,32.1,63.2,33.9V192h13.7v-21.4\r\n\tc24.5-1.9,47.2-14,62.4-33.4l10.7,6.4l0.7-40.8L145.8,122.6z M70.7,51.2c0-16.3,13.2-29.5,29.5-29.5c16.3,0,29.5,13.2,29.5,29.5\r\n\tc0,16.3-13.2,29.5-29.5,29.5C83.9,80.7,70.7,67.5,70.7,51.2z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/锚地.svg
// module id = 2J6C
// module chunks = 15